import cx from "classnames";
import { SingleLineEditor } from "common/SingleLineEditor";
import React from "react";
import { defineMessages, injectIntl } from "react-intl";
import styles from "./BlockCaption.scss";

const message = defineMessages({
  caption: {
    id: "BlockCaption.caption",
    defaultMessage: "Write a caption",
  },
});

class _BlockCaption extends React.Component {
  updateCaption = (caption) => {
    this.props.blockProps.onChange({ caption });
  };

  onKeyDown = (e) => {
    // up/down arrows now handled by letting key events fall through to parent
    const DELETE = 8;
    const ENTER = 13;

    if (e.keyCode === DELETE) {
      // prevent hitting backspace in a caption from deleting blocks
      e.stopPropagation();
    }

    if (e.keyCode === ENTER) {
      e.stopPropagation();
    }
  };

  render() {
    const { intl } = this.props;
    const data = this.props.block.getData();
    const caption = data.get("caption");
    const captionEmpty = !caption || caption.length === 0;
    const captionClass = cx(styles.BlockCaption, captionEmpty && styles.placeholder);

    return (
      <figcaption className={captionClass} onKeyDown={this.onKeyDown}>
        <SingleLineEditor
          defaultValue={caption}
          placeholder={intl.formatMessage(message.caption)}
          onChange={(caption) => this.updateCaption(caption)}
          textAlignment="center"
          type="caption"
        />
        <div className={styles.closeButton} />
      </figcaption>
    );
  }
}

export const BlockCaption = injectIntl(_BlockCaption);
